module.exports = __webpack_public_path__ + "src/img/search.bb39f986.svg";